import React, { useEffect, useState } from 'react'
import './App.css'
import { useHistory, useLocation } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import { IoIosArrowBack } from 'react-icons/io'
import { BiRefresh, BiMenu } from 'react-icons/bi'
import Summary from './components/payouts/Summary'
import PayoutRequestList from './components/payouts/PayoutRequestList'
import Breakdown from './components/payouts/Breakdown'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'

// Match these to your SideNav CSS widths
const SIDEBAR_WIDTH = 240
const SIDEBAR_COLLAPSED_WIDTH = 72

const Payout = () => {
  const [count, setCount] = useState(0)
  const [refreshing, setRefreshing] = useState(false)
  const history = useHistory()
  const location = useLocation()
  const { eventid, eventname, is_sponsorship } = location.state || {}
  const event_id = eventid
  const event_name = eventname || 'Event Name Not Provided'

  const [isMob, setIsMob] = useState(window.innerWidth <= 768)
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth <= 768
      setIsMob(mobile)
      setCollapsed((prev) => (mobile ? true : prev))
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const handleToggle = () => setCollapsed((prev) => !prev)
  const sidebarOffset = isMob ? 0 : collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH

  const refreshView = () => {
    return (
      <label
        className="refresh-btn"
        title="Refresh"
        data-for="refreshSummary"
        data-tip="Refresh"
        style={{ cursor: 'pointer', marginTop: '-10px' }}
        onClick={() => {
          setCount(count + 1)
          setRefreshing(true)
        }}
      >
        {refreshing ? 'Updating...' : ''} <BiRefresh size={30} />
        <ReactTooltip id="refreshSummary" place="top" type="dark" effect="solid" className="p-1" />
      </label>
    )
  }

  return (
    <div className="view mt-5">
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />

      {isMob && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}
      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <div
        className="containe pl-1 pr-1"
        style={{
          marginLeft: sidebarOffset,
          width: `calc(100% - ${sidebarOffset}px)`,
          transition: 'margin-left .25s ease, width .25s ease',
        }}
      >
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-12 mt-5 mb-4">
            {is_sponsorship == true ? (
              <div className="sponsored-badge w-100 p-2 text-center" style={{ fontSize: 16 }}>
                🌟 Tickets to this event are proudly sponsored by Karamale.
              </div>
            ) : (
              ''
            )}
          </div>

          <div className="col-lg-12">
            <div className="col-12 mb-0 text-right">
              <label className="">
                {refreshView()} |
                <span className="cursor-pointer" onClick={() => history.goBack()}>
                  <IoIosArrowBack size={25} /> Back
                </span>
              </label>
            </div>

            <div className="BoxDashboardContainer mb-4 pb-3 pl-3 pr-3 w-100">
              <div className="row justify-content-center w-100">
                <label className="text-left w-100">
                  <h3
                    style={{
                      fontWeight: 700,
                      fontSize: 24,
                      margin: '4px 0 16px',
                      textAlign: 'left',
                    }}
                  >
                    {String(event_name)
                      .toLowerCase()
                      .replace(/(^|[\s\-–(/&])([a-z])/g, (_, s, c) => s + c.toUpperCase())}
                  </h3>
                </label>
                <div className="col-12 p-0">
                  <PayoutRequestList
                    eventid={event_id}
                    count={count}
                    setRefreshing={setRefreshing}
                    source={'organiserPayout'}
                  />
                </div>
                <div className="col-12 p-0">
                  <Summary eventid={event_id} count={count} />
                </div>
                <div className="col-12 p-0">
                  <Breakdown eventid={event_id} count={count} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Payout
